import Vue from 'vue'
import Router from 'vue-router'
// Containers
import Full from '@/containers/Full'
// Views
import PortalStart from '@/views/portal/Start'
import Udbud from '@/views/portal/udbud'
import TedUdbud from '@/views/portal/ted_udbud'
import NewMeetings from '@/views/portal/NewMeetings'
// import Aflysninger from '@/views/portal/Aflysninger'
import AllMeetings from '@/views/portal/AllMeetings'
import AllMeetings_minbolig from '@/views/portal/AllMeetings_minbolig'
import MainPage from '@/views/portal/MainPage'
import Balance from '@/views/portal/Balance'
import ProfileSettings from '@/views/portal/ProfileSettings'
import integrationSettings from '@/views/portal/integrationSettings'
import leverandoerservice from '@/views/portal/leverandoerservice'
// import ProfileSettingsother from '@/views/portal/ProfileSettingsother'
import Opgavetyper from '@/views/portal/Opgavetyper'
import Ferieperioder from '@/views/portal/Ferieperioder'
import Ekstraphone from '@/views/portal/ekstraphone'
import Profilside from '@/views/portal/Profilside'
import ConfirmDescription from '@/views/portal/confirm-description'
import Opgaveoversigt from '@/views/portal/Opgaveoversigt'
import Anbefalinger from '@/views/portal/Anbefalinger'
import Anbefaling from '@/views/portal/Anbefaling'
import CreditCard from '@/views/portal/EditCreditCard'
import visitKort from '@/views/portal/EditvisitKort'
import ExpireSubscription from '@/views/portal/ExpireSubscription'
import ExpireSubscriptionForm from '@/views/portal/ExpireSubscriptionForm'
import ProjectLogin from '@/views/ProjectLogin'
import Security from '@/views/Security'
// micrositesv1
import Invo from '@/views/micrositesv1/invo'
import Package from '@/views/micrositesv1/package'
import Singupcvr from '@/views/micrositesv1/singupcvr'
import Signup from '@/views/micrositesv1/signupv2'
import Signupv2 from '@/views/micrositesv1/signupv2'
import SignupAIText from '@/views/micrositesv1/signup_AI_text'
import Inviterepartner from '@/views/micrositesv1/inviterepartner'
import Contractviewer from '@/views/micrositesv1/contract-viewer'
import Demo from '@/views/micrositesv1/demov2'
import Demov2 from '@/views/micrositesv1/demov2'
import Acceptancemobilepay from '@/views/micrositesv1/mobilepay'
import Callme from '@/views/micrositesv1/callme'
import Unsubscribe from '@/views/micrositesv1/unsubscribe'

import Password from '@/views/Password'
import Finansiering from '@/views/portal/Finansiering'
import CreditCheck from '@/views/portal/CreditCheck'
import NewStatusList from '@/views/portal/NewProjectStatus'
import NewHaandvaerkerStatusList from '@/views/portal/NewHaandvaerkerProjectStatus'
import NewHaandvaerkerStatusList2 from '@/views/portal/NewHaandvaerkerProjectStatus2'
import CustomerProjects from '@/views/portal/CustomerProjects'
import Purchase from '@/views/portal/Purchase'
import anbefalktohomeowners from '@/views/portal/anbefalktohomeowners'
// import CreateProject from '@/views/portal/OpretProjekt'
import PrivatMarkedsplads from '@/views/portal/Marketplace'
import PrivatMarkedsplads2 from '@/views/portal/Marketplace2'
import Openminbolig2job from '@/views/portal/MarketplaceMinbolig2'
import CreateProjectNew from '@/views/portal/OpretProjektNew'
import CreateProjectNewv2 from '@/views/portal/opretprojektnew/CreateProjectNew'
import CreateProjectNewv2tak from '@/views/portal/opretprojektnew/CreateProject_Tak'
import CreateProjectNewvEditPage from '@/views/portal/opretprojektnew/CreateProject_edit'
import CreateProjectNewuploadbilleder from '@/views/portal/opretprojektnew/uploadimage'
import AddProject from '@/views/portal/AddProjects'
import Website from '@/views/portal/Website'
import WriteSupport from '@/views/portal/WriteSupport'
import Inbox from '@/views/portal/Inbox'
// import NewInbox from '@/views/portal/NewInbox'
import Email from '@/views/portal/email'
import Chat from '@/views/portal/Chat'
import Jule from '@/views/portal/jule'
import Invite from '@/views/portal/invite'
import ForgotPassword from '@/views/ForgotPassword'
import Newsfeed from '@/views/portal/Newsfeed'
import PartnerSetup from '@/views/PartnerSetup'
import userTilbud from '@/views/portal/userTilbud'
import Tilbudhistorie from '@/views/portal/StandardTilbudhistory'
import standardTilbud from '@/views/portal/standardTilbud'
import StandardTilbudProduct from '@/views/portal/standardTilbudProduct'
import hurtigtTilbud from '@/views/portal/standardTilbud'
import uploadTilbud from '@/views/portal/standardTilbud'
import MesterArbejdskraft from '@/views/portal/MesterArbejdskraft'
import MesterOpgaver from '@/views/portal/MesterOpgaver'
import IndhentAnbefalinger from '@/views/portal/IndhentAnbefalinger'
import ReadAnbefalinger from '@/views/portal/ReadAnbefalinger'
import Widgets from '@/views/portal/Widgets'
import AllSettings from '@/views/portal/AllSettings'
import InviterKollega from '@/views/portal/InviterKollega'
import stamoplysninger from '@/views/portal/stamoplysninger'
import medlemsfordele from '@/views/portal/medlemsfordele'
// import TilfojOverskrift from '@/views/portal/tilbud/TilfojOverskrift'
import overview from '@/views/portal/webshop/overview'
import products from '@/views/portal/webshop/products'
import product from '@/views/portal/webshop/product'
import cart from '@/views/portal/webshop/cart'
import checkout from '@/views/portal/webshop/checkout'
import orders from '@/views/portal/webshop/orders'
import order from '@/views/portal/webshop/order'
import wishlist from '@/views/portal/webshop/wishlist'
import FbAds from '@/views/portal/webshop/FbAds'
import GoogleAds from '@/views/portal/webshop/GoogleAds'
import BoostProfilside from '@/views/portal/webshop/BoostProfilside'
import BoostProjekt from '@/views/portal/webshop/BoostProjekt'
import BoostEnAnbefaling from '@/views/portal/webshop/BoostEnAnbefaling'
import TermsAndConditions from '@/views/portal/webshop/TermsAndConditions'
import badges from '@/views/portal/badges'
import pressArticle from '@/views/portal/press-article'
import klima from '@/views/portal/klima/klima'
import klimachecklist from '@/views/portal/klima/checklist'
import survey from '@/views/portal/klima/survey'
import editsurvey from '@/views/portal/klima/editsurvey'
import registration from '@/views/portal/klima/registration'
import documentation from '@/views/portal/klima/dokumentation'
import Recommend from '@/views/portal/recommend'
import faq from '@/views/portal/faq'
import ordrestyring from '@/views/portal/ordrestyring'
import approval from '@/views/portal/approval'
import nps from '@/views/portal/nps'
import UddanelseBevis from '@/views/portal/UddanelseBevis'
import Questionnaire from '@/views/Questionnaire'
import QuestionnaireThankyou from '@/views/QuestionnaireThankyou'
import contracts from '@/views/portal/contracts'
import NewInbox from '@/views/portal/messages/inbox'
import Sent from '@/views/portal/messages/sent'
import Timeline from '@/views/portal/customerprojects/timeline'
import ProjectDashboard from '@/views/portal/customerprojects/ProjectDashboard'
import ApprovedProjects from '@/views/portal/customerprojects/ApprovedProjects'
import CustomerContract from '@/views/portal/customerprojects/contract'
import Calendar from '@/views/portal/customerprojects/calendar'
import ContractManager from '@/views/portal/customerprojects/contract-manager'
import ContractMain from '@/views/portal/customerprojects/contract-main'
import ContractMainTak from '@/views/portal/customerprojects/contract-main-tak'
import ContractMainv2 from '@/views/portal/customerprojects/contract-mainv2'
import draftContract from '@/views/portal/customerprojects/contract_draft'
import draftContractXtrawork from '@/views/portal/customerprojects/contract_extrawork_addon'
import Extraworklist from '@/views/portal/customerprojects/extraworklist'
import ProjectImages from '@/views/portal/customerprojects/projekt-billeder'
import Paymentmanagement from '@/views/portal/customerprojects/payment-management'
import MangelList from '@/views/portal/customerprojects/mangel-list'
import PropertyOwner from '@/views/portal/PropertyOwner'
import PayproffUpdate from '@/views/portal/payproff'
import Version from '@/views/portal/version'
import Files from '@/views/portal/customerprojects/documents'
import Tender from '@/views/portal/customerprojects/tenderFolder'
import Addendum from '@/views/portal/addendum'
import Worksheet from '@/views/portal/worksheet'

Vue.use(Router)
export default new Router({
    mode: 'hash', // Demo is living in GitHub.io, so required!
    linkActiveClass: 'active',
    scrollBehavior: () => ({
        y: 0
    }),
    routes: [{
            path: '/login',
            name: 'ProjectLogin',
            component: ProjectLogin
        },
        {
            path: '/invo/*',
            name: 'Invo',
            component: Invo
        },
        {
            path: '/package/*',
            name: 'Package',
            component: Package
        },
        {
            path: '/singupcvr/*',
            name: 'Singupcvr',
            component: Singupcvr
        },
        {
            path: '/signup/*',
            name: 'Signup',
            component: Signupv2 // pointing to new version,  Signup is the old
        },
        {
            path: '/upgrade/*',
            name: 'SignupAIText',
            component: SignupAIText // pointing to new version,  Signup is the old
        },
        {
            path: '/signupv2/*',
            name: 'Signupv2',
            component: Signupv2
        },
        {
            path: '/inviterepartner/*',
            name: 'Inviterepartner',
            component: Inviterepartner
        },
        {
            path: '/contract-viewer/*',
            name: 'Contractviewer',
            component: Contractviewer
        },
        {
            path: '/demo/*',
            name: 'Demo',
            component: Demov2 // pointing to new version,  Demo is the old
        },
        {
            path: '/demov2/*',
            name: 'Demov2',
            component: Demov2
        },
        {
            path: '/mobilepay/*',
            name: 'Acceptancemobilepay',
            component: Acceptancemobilepay
        },
        {
            path: '/kontakt/*',
            name: 'Callme',
            component: Callme
        },
        {
            path: '/unsubscribe/*',
            name: 'Unsubscribe',
            component: Unsubscribe
        },
        {
            path: '/security',
            name: 'Security',
            component: Security
        },
        // {
        //   path: '/password',
        //   name: 'Password',
        //   component: Password
        // },
        {
            path: '/glemte-password',
            name: 'Glemte Password',
            component: ForgotPassword
        },
        {
            path: '/partnerfri-setup',
            name: 'PartnerSetup',
            component: PartnerSetup
        },
        {
            path: '/',
            redirect: '/newsfeed',
            name: '',
            component: Full,
            children: [{
                    path: '/newsfeed',
                    name: 'Newsfeed',
                    component: Newsfeed
                },
                {
                    path: '/recommend',
                    name: 'Anbefal os',
                    component: Recommend
                },
                {
                    path: '/skriv-til-support',
                    name: 'Skriv til support',
                    component: WriteSupport
                },
                {
                    path: '/hjemmeside',
                    name: 'Hjemmeside',
                    component: Website
                },
                {
                    path: '/tilfoej-projekter',
                    name: 'Tilføj Projekter',
                    component: AddProject
                },
                {
                    path: '/indhent-anbefalinger',
                    name: 'Indhent Anbefalinger',
                    component: IndhentAnbefalinger
                },
                {
                    path: '/laes-og-besvar-anbefalinger',
                    name: 'Læs og besvar',
                    component: ReadAnbefalinger
                },
                {
                    path: '/opret-projekt-new',
                    name: 'Create',
                    component: CreateProjectNew
                },
                {
                    path: '/opret-projekt-new/wizard',
                    name: 'CreateProjectNewv2',
                    component: CreateProjectNewv2
                },
                {
                    path: '/opret-projekt-new/tak',
                    name: 'CreateProjectNewv2tak',
                    component: CreateProjectNewv2tak
                },
                {
                    path: '/opret-projekt-new/rediger_projekt',
                    name: 'CreateProjectNewvEditPage',
                    component: CreateProjectNewvEditPage
                },
                {
                    path: '/opret-projekt-new/billeder',
                    name: 'CreateProjectNewuploadbilleder',
                    component: CreateProjectNewuploadbilleder

                },
                {
                    path: '/markedsplads',
                    name: 'PrivatMarkedsplads',
                    component: PrivatMarkedsplads
                },
                {
                    path: '/anbefaling-boligejere',
                    name: 'anbefalktohomeowners',
                    component: anbefalktohomeowners
                },
                {
                    path: '/anbefalinger-sammendrag',
                    name: 'Anbefaling',
                    component: Anbefaling
                },
                {
                    path: '/koeb-projekter',
                    name: 'Purchase',
                    component: Purchase
                },
                {
                    path: '/status-haandvaerker',
                    name: 'Haandvaerker - Status',
                    component: NewHaandvaerkerStatusList
                },
                {
                    path: '/status-haandvaerker-new',
                    name: 'Projekter',
                    component: NewHaandvaerkerStatusList2
                },
                {
                    path: '/customer-projects',
                    name: 'CustomerProjects',
                    component: CustomerProjects
                },
                {
                    path: '/status-producenter',
                    name: 'Producenter - Status',
                    component: NewStatusList
                },
                {
                    path: '/ted_status',
                    name: 'TedUdbud',
                    component: TedUdbud
                },
                {
                    path: '/new-meetings',
                    name: 'New Meetings',
                    component: NewMeetings
                },
                {
                    path: '/mester-arbejdskraft',
                    name: 'Arbejdskraft',
                    component: MesterArbejdskraft
                },
                {
                    path: '/mester-opgaver',
                    name: 'Opgaver',
                    component: MesterOpgaver
                },
                {
                    path: '/settings',
                    name: 'Settings',
                    component: AllSettings
                },
                {
                    path: '/alle-moeder',
                    name: 'Alle møder',
                    component: AllMeetings
                },
                {
                    path: '/alle-moeder-minbolig',
                    name: 'Alle møder-minbolig',
                    component: AllMeetings_minbolig
                },
                {
                    path: '/userTilbud',
                    name: 'Tilbud',
                    component: userTilbud
                },
                {
                    path: '/oversigt',
                    name: 'Oversigt',
                    component: MainPage
                },
                {
                    path: '/balance',
                    name: 'Balance',
                    component: Balance
                },
                {
                    path: '/dine-indstillinger',
                    name: 'Dine Indstillinger',
                    component: ProfileSettings
                },
                {
                    path: '/faq',
                    name: 'Ofte stillede spørgsmål',
                    component: faq
                },
                {
                    path: '/auto-anbefalinger',
                    name: 'Dine Integrationer',
                    component: integrationSettings
                },
                {
                    path: '/widgets',
                    name: 'Widgets',
                    component: Widgets
                },
                {
                    path: '/leverandoerservice',
                    name: 'Tilmeld Betalingsaftale',
                    component: leverandoerservice
                },
                {
                    path: '/dine-opgavetyper',
                    name: 'Dine Opgavetyper',
                    component: Opgavetyper
                },
                {
                    path: '/dine-ferieperioder',
                    name: 'Dine Ferieperioder',
                    component: Ferieperioder
                },
                {
                    path: '/klima',
                    name: 'Klima',
                    component: klima
                },
                {
                    path: '/ekstraphone',
                    name: 'Ekstra phone',
                    component: Ekstraphone
                },
                {
                    path: '/profilside',
                    name: 'Din profilside',
                    component: Profilside
                },
                {
                    path: '/confirm-description',
                    name: 'ConfirmDescription',
                    component: ConfirmDescription
                },
                {
                    path: '/anbefalinger',
                    name: 'Anbefalinger',
                    component: Anbefalinger
                },
                {
                    path: '/kundeoversigt',
                    name: 'Opgaveoversigt',
                    component: Opgaveoversigt
                },
                {
                    path: '/rediger-kreditkort-oplysninger',
                    name: 'Rediger kreditkort oplysninger',
                    component: CreditCard
                },
                {
                    path: '/visitkort',
                    name: 'Køb streamers og visitkort',
                    component: visitKort
                },
                {
                    path: '/expire-subscription',
                    name: 'Abommanet',
                    component: ExpireSubscription
                },
                {
                    path: '/expire-subscription-form',
                    name: 'Abonnement',
                    component: ExpireSubscriptionForm
                },
                {
                    path: '/finansiering',
                    name: 'Finansiering',
                    component: Finansiering
                },
                {
                    path: '/kredit-tjek',
                    name: 'Kredittjek',
                    component: CreditCheck
                },
                {
                    path: '/inbox',
                    name: 'Inbox',
                    component: Inbox
                },
                // {
                //     path: '/new-inbox',
                //     name: 'NewInbox',
                //     component: NewInbox
                // },
                {
                    path: '/email',
                    name: 'Email',
                    component: Email
                },
                {
                    path: '/chat',
                    name: 'Chat',
                    component: Chat
                },
                {
                    path: '/stamoplysninger',
                    name: 'Din stamoplysninger',
                    component: stamoplysninger
                },
                {
                    path: '/jule',
                    name: 'Jule',
                    component: Jule
                },
                {
                    path: '/invitation',
                    name: 'Invitation',
                    component: Invite
                },
                {
                    path: '/inviter-en-kollega',
                    name: 'Inviter en kollega',
                    component: InviterKollega
                },
                {
                    path: '/password',
                    name: 'Password',
                    component: Password
                },
                {
                    path: '/medlemsfordele',
                    name: 'Medlemsfordele',
                    component: medlemsfordele
                },
                {
                    path: '/badges',
                    name: 'Digitale præmier',
                    component: badges
                },
                {
                    path: '/Artikel',
                    name: 'pressArticle',
                    component: pressArticle
                },
                {
                    path: '/ordrestyring',
                    name: 'Ordrestyring',
                    component: ordrestyring
                },
                {
                    path: '/approval',
                    name: 'Kundebekræftelse',
                    component: approval
                },
                {
                    path: '/approval/nps',
                    name: 'NPS',
                    component: nps
                },
                {
                    path: '/uddannelsesbevis',
                    name: 'UddanelseBevis',
                    component: UddanelseBevis
                },
                {
                    path: '/contracts',
                    name: 'Contracts',
                    component: contracts
                },
                {
                    path: '/version',
                    name: 'Version',
                    component: Version
                },
                {
                    path: '/property-owner',
                    name: 'Property owner',
                    component: PropertyOwner
                },
                {
                    path: '/konto-update',
                    name: 'PayproffUpdate',
                    component: PayproffUpdate
                },
                {
                    path: '/addendum',
                    name: 'Addendum',
                    component: Addendum
                },
                {
                    path: '/worksheet',
                    name: 'Worksheet',
                    component: Worksheet
                }
            ]
        }, {
            path: '/markedsplads',
            name: '',
            component: Full,
            children: [{
                path: '/privat-udbud',
                name: 'Privat Udbud',
                component: PrivatMarkedsplads
            },
            {
                path: '/privat-udbud-bitrix',
                name: 'Privat Udbud2',
                component: PrivatMarkedsplads2
            },
            {
                path: '/offentlige-udbud',
                name: 'Offentlige Udbud',
                component: Udbud
            },
            {
                path: '/opgaveinvitationer',
                name: 'Openminbolig2job',
                component: Openminbolig2job
            }
            ]
        },
        {
            path: '/tilbud',
            name: '',
            component: Full,
            children: [{
                    path: '/tilbud/tilbud-historie',
                    name: 'Tilbudshistorie',
                    component: Tilbudhistorie
                },
                {
                    path: '/tilbud/standardTilbud',
                    name: 'StandardTilbud',
                    component: standardTilbud
                },
                {
                    path: '/tilbud/hurtigt-tilbud',
                    name: 'HurtigtTilbud',
                    component: standardTilbud
                },
                {
                    path: '/tilbud/upload-tilbud',
                    name: 'UploadTilbud',
                    component: uploadTilbud
                },
                {
                    path: '/tilbud/standardTilbudProduct',
                    name: 'StandardTilbudProduct',
                    component: StandardTilbudProduct
                }
            ]
        },
        {
            path: '/webshop',
            name: '',
            component: Full,
            children: [{
                    path: '/webshop/overview',
                    name: 'WebShop Oversigt',
                    component: overview
                },
                {
                    path: '/webshop/product',
                    name: 'Product',
                    component: product
                },
                {
                    path: '/webshop/products',
                    name: 'Products',
                    component: products
                },
                {
                    path: '/webshop/cart',
                    name: 'Cart',
                    component: cart
                },
                {
                    path: '/webshop/checkout',
                    name: 'Checkout',
                    component: checkout
                },
                {
                    path: '/webshop/orders',
                    name: 'Orders',
                    component: orders
                },
                {
                    path: '/webshop/order',
                    name: 'Order',
                    component: order
                },
                {
                    path: '/webshop/wishlist',
                    name: 'Wish List',
                    component: wishlist
                },
                {
                    path: '/webshop/fb-ads',
                    name: 'Fb Ads',
                    component: FbAds
                },
                {
                    path: '/webshop/google-ads',
                    name: 'Google Ads',
                    component: GoogleAds
                },
                {
                    path: '/webshop/boost-profilside',
                    name: 'Boost profileside',
                    component: BoostProfilside
                },
                {
                    path: '/webshop/boost-projekt',
                    name: 'Boost projekt',
                    component: BoostProjekt
                },
                {
                    path: '/webshop/boost-en-anbefaling',
                    name: 'Boost anbefale',
                    component: BoostEnAnbefaling
                },
                {
                    path: '/webshop/terms-and-conditions',
                    name: 'Terms and Conditions',
                    component: TermsAndConditions
                }
            ]
        },
        {
            path: '/klima',
            name: '',
            component: Full,
            children: [{
                    path: '/klima/klima',
                    name: 'Klima Plan',
                    component: klima
                },
                {
                    path: '/klima/checklist',
                    name: 'Klima Checklist',
                    component: klimachecklist
                },
                {
                    path: '/klima/survey',
                    name: 'Klima - Customer Checklist',
                    component: survey
                },
                {
                    path: '/klima/editsurvey',
                    name: 'Klima - Edit Checklist',
                    component: editsurvey
                },
                {
                    path: '/klima/registration',
                    name: 'Klima - Register Fag',
                    component: registration
                },
                {
                    path: '/klima/documentation',
                    name: 'Documentation',
                    component: documentation
                }
            ]
        },
        {
            path: '/questionnaire',
            name: 'Questionnaire',
            component: Questionnaire
        },
        {
            path: '/questionnaire-thankyou',
            name: 'Questionnaire Thankyou',
            component: QuestionnaireThankyou
        },
        {
            path: '/messages/inbox',
            name: '',
            component: Full,
            children: [{
                    path: '/messages/inbox',
                    name: 'Indbakke',
                    component: NewInbox
                },
                {
                    path: '/messages/sent',
                    name: 'Sendt',
                    component: Sent
                }
            ]
        },
        {
            path: '/',
            name: '',
            component: Full,
            children: [{
                    path: '/customer-projects/timeline',
                    name: 'Timeline',
                    component: Timeline
                },
                {
                    path: '/customer-projects/project-dashboard',
                    name: 'ProjectsDashboard',
                    component: ProjectDashboard
                },
                {
                    path: '/customer-projects/approved-projects',
                    name: 'ApprovedProjects',
                    component: ApprovedProjects
                },
                {
                    path: '/customer-projects/contract',
                    name: 'Contract',
                    component: CustomerContract
                },
                {
                    path: '/customer-projects/calendar',
                    name: 'Calendar',
                    component: Calendar
                },
                {
                    path: '/customer-projects/contract-manager',
                    name: 'ContractManager',
                    component: ContractManager
                },
                {
                    path: '/customer-projects/contract-main',
                    name: 'ContractMain',
                    component: ContractMain
                },
                {
                    path: '/customer-projects/contract-main-tak',
                    name: 'ContractMainTak',
                    component: ContractMainTak
                },
                {
                    path: '/customer-projects/contract-mainv2',
                    name: 'ContractMainv2',
                    component: ContractMainv2
                },
                {
                    path: '/customer-projects/contract-draft',
                    name: 'draftContract',
                    component: draftContract
                },
                {
                    path: '/customer-projects/contract-addon',
                    name: 'draftContractXtrawork',
                    component: draftContractXtrawork
                },
                {
                    path: '/customer-projects/addon-liste',
                    name: 'Extraworklist',
                    component: Extraworklist
                },
                {
                    path: '/customer-projects/payment-management',
                    name: 'Paymentmanagement',
                    component: Paymentmanagement
                },
                {
                    path: '/customer-projects/mangel-liste',
                    name: 'MangelList',
                    component: MangelList
                },
                {
                    path: '/customer-projects/projekt-billeder',
                    name: 'ProjectImages',
                    component: ProjectImages
                },
                {
                    path: '/customer-projects/documents',
                    name: 'Documents',
                    component: Files
                },
                {
                    path: '/customer-projects/tender',
                    name: 'Documents-Tender',
                    component: Tender
                }
            ]
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js